import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '@core/auth/auth-guard.service';
import { NoAccessComponent } from '@shared/components/no-access/no-access.component';
import { PageNotFoundComponent } from '@shared/components/page-not-found/page-not-found.component';

export const researchesPath = 'researches';
export const clientPath = 'client/researches';

const routes: Routes = [
  {
    path: '',
    redirectTo: researchesPath,
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('@features/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: researchesPath,
    loadChildren: () => import('@features/researches/researches.module').then((m) => m.ResearchesModule),
    canActivate: [AuthGuardService]
  },
  {
    path: clientPath + '/:id',
    loadChildren: () => import('@features/client/client.module').then((m) => m.ClientModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'no-access',
    component: NoAccessComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
